export default class ReservationResponse {
    constructor(data) {
        Object.defineProperty(this, "customer_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "enc_res_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "redirect_uri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reservation_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "uniqueErrorId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data || !data.success) {
            this.status = false;
            this.error = (data === null || data === void 0 ? void 0 : data.original_message) || (data === null || data === void 0 ? void 0 : data.message);
            this.errorCode = data === null || data === void 0 ? void 0 : data.error_code;
            this.uniqueErrorId = data === null || data === void 0 ? void 0 : data.unique_id;
            return;
        }
        this.status = true;
        this.reservation_id = data.reservation_id;
        this.enc_res_id = data.enc_res_id;
        this.customer_id = parseInt(data.customer_id);
        this.nextAction = data.next_action;
        if (data.redirect_uri) {
            const { postData } = data.redirect_uri;
            this.redirect_uri = {
                method: data.redirect_uri.method,
                postData: Array.isArray(postData) ? undefined : postData,
                url: data.redirect_uri.url,
            };
        }
    }
}
